<div class="wrapper">
    <div class="features-4">
        <h2 class="title">Automation & RPA portfolio</h2>
        <div class="container">
            <app-rpa-area></app-rpa-area>
        </div>
    </div>

    <app-footer-main></app-footer-main>
</div>
